import { createRequest } from '@direct-frontend/modules-request';

/**
 * Запросы к геокодеру
 */
export const request = createRequest({
    baseUrl: () => 'https://geocode-maps.yandex.ru/1.x/',
    timeout: { connect: 100, request: 1000 },
    agent: false,
    retry: 2,
});
